import { TestIdDomain } from 'constants/testIds';

const UnderwritingTestIdsScope = {
  ADD_BROKER_CONDITION_FORM: 'add-broker-condition-form',
  ADD_CONDITION_FORM: 'add-condition-form',
  BROKER_CONDITION_FORM: 'broker-condition-form',
  DOC_EXPIRATION: 'doc-expiration',
  DOC_EXPIRATION_FORM: 'doc-expiration-form',
  GENERAL_FORM: 'general-form',
  LOAN_BUNDLE: 'loan-bundle',
  LOAN_CONDITIONS: 'loan-conditions',
  LOAN_DENIAL: 'loan-denial',
  LOAN_DENIAL_FORM: 'loan-denial-form',
  NOTES: 'notes',
  NOTES_FORM: 'notes-form',
  UW_REPORTS: 'uw-reports',
};

export const UnderwritingTestIds = {
  // AddBrokerConditionForm
  ADD_BROKER_CONDITION_FORM: `${TestIdDomain.UNDERWRITING}.${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}`,
  ADD_BROKER_CONDITION_FORM_BORROWER_INTERNAL_TEXT_INPUT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.borrower-internal-text-input`,
  ADD_BROKER_CONDITION_FORM_INTERNAL_TEXT_INPUT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.internal-text-input`,
  ADD_BROKER_CONDITION_FORM_SUBMIT_BUTTON: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.submit-button`,

  // AddConditionFormTaskType
  ADD_CONDITION_FORM_DESCRIPTION_INPUT: `${UnderwritingTestIdsScope.ADD_CONDITION_FORM}.description-input`,

  // CancelSendingBundlePopup
  BROKER_CONDITION_FORM: `${TestIdDomain.UNDERWRITING}.${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}`,
  BROKER_CONDITION_FORM_CANCEL_CD_BUNDLE_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.cancel-cd-bundle-button`,

  // Conditions
  LOAN_CONDITIONS_ADD_BUTTON: `${UnderwritingTestIdsScope.LOAN_CONDITIONS}.add-button`,

  // GeneralForm
  GENERAL_FORM: `${TestIdDomain.UNDERWRITING}.${UnderwritingTestIdsScope.GENERAL_FORM}`,
  GENERAL_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.GENERAL_FORM}.cancel-button`,
  GENERAL_FORM_SUBMIT_BUTTON: `${UnderwritingTestIdsScope.GENERAL_FORM}.submit-button`,

  // KeyDates
  KEY_DATES_SECTION: `${TestIdDomain.UNDERWRITING}.key-dates-section`,

  // LoanConditionTable
  LOAN_CONDITION_TABLE: `${TestIdDomain.UNDERWRITING}.loan-condition-table`,

  // LoanConditionTableItem
  BROKER_CONDITION_FORM_SIGN_OFF_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.sign-off-button`,
  BROKER_CONDITION_FORM_DELETE_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.delete-button`,
  BROKER_CONDITION_FORM_UNSIGN_OFF_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.unsign-off-button`,

  // LoanDenialForm
  LOAN_DENIAL_FORM: `${TestIdDomain.UNDERWRITING}.${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}`,
  LOAN_DENIAL_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.cancel-button`,
  LOAN_DENIAL_FORM_SUBMIT_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.submit-button`,

  // Notes
  NOTES_ADD_BUTTON: `${UnderwritingTestIdsScope.NOTES}.add-button`,
  NOTES_ACTION_BUTTON: `${UnderwritingTestIdsScope.NOTES}.action-button`,

  // NoteForm
  NOTES_FORM: `${TestIdDomain.UNDERWRITING}.${UnderwritingTestIdsScope.NOTES_FORM}`,
  NOTES_FORM_NOTES_INPUT: `${UnderwritingTestIdsScope.NOTES_FORM}.notes-input`,
  NOTES_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.NOTES_FORM}.cancel-button`,
  NOTES_FORM_SUBMIT_BUTTON: `${UnderwritingTestIdsScope.NOTES_FORM}.submit-button`,

  // DocumentExpirationDates
  DOC_EXPIRATION_ADD_BUTTON: `${UnderwritingTestIdsScope.DOC_EXPIRATION}.add-button`,
  DOC_EXPIRATION_TABLE: `${UnderwritingTestIdsScope.DOC_EXPIRATION}.table`,
  DOC_EXPIRATION_ROW_ACTION_BUTTON: `${UnderwritingTestIdsScope.DOC_EXPIRATION}.row-action-button`,
  DOC_EXPIRATION_FORM: `${TestIdDomain.UNDERWRITING}.${UnderwritingTestIdsScope.DOC_EXPIRATION_FORM}`,
  DOC_EXPIRATION_FORM_TITLE_INPUT: `${UnderwritingTestIdsScope.DOC_EXPIRATION_FORM}.title-input`,
  DOC_EXPIRATION_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.DOC_EXPIRATION_FORM}.cancel-button`,
  DOC_EXPIRATION_FORM_SAVE_BUTTON: `${UnderwritingTestIdsScope.DOC_EXPIRATION_FORM}.save-button`,

  // LoanBundleHistory
  LOAN_BUNDLE_VIEW_DOCUMENTS_BUTTON: `${UnderwritingTestIdsScope.LOAN_BUNDLE}.view-documents-button`,
  LOAN_BUNDLE_ACTION_BUTTON: `${UnderwritingTestIdsScope.LOAN_BUNDLE}.action-button`,
  LOAN_BUNDLE_CANCEL_SENDING_BUTTON: `${UnderwritingTestIdsScope.LOAN_BUNDLE}.cancel-sending-button`,

  // UwReports
  UW_REPORTS_TABLE: `${UnderwritingTestIdsScope.UW_REPORTS}.table`,
  UW_REPORTS_ACTION_MENU: `${UnderwritingTestIdsScope.UW_REPORTS}.action-menu`,
  UW_REPORTS_GENERATE_NEW_REPORT_BUTTON: `${UnderwritingTestIdsScope.UW_REPORTS}.generate-new-report-button`,
  UW_REPORTS_INCOMES_SECTION: `${UnderwritingTestIdsScope.UW_REPORTS}.incomes-section`,
  UW_REPORTS_QUALIFIED_INCOMES_TABLE: `${UnderwritingTestIdsScope.UW_REPORTS}.qualified-incomes-table`,
  UW_REPORTS_VALIDATION_RULES_TABLE: `${UnderwritingTestIdsScope.UW_REPORTS}.validation-rules-table`,

  // Dynamic
  getUwReportItemId: reportId => `uw-report-item.report-${reportId}`,
  getUwReportItemHeaderId: reportId => `uw-report-item-${reportId}.header`,
  getConditionHeaderId: priorTo => `condition-${priorTo}.header`,
  getFormBundleHistoryHeaderId: formBundleSignatureRequestId =>
    `form-bundle-${formBundleSignatureRequestId}.history-header`,
  getFormBundleTableId: formBundleSignatureRequestId =>
    `form-bundle.table-${formBundleSignatureRequestId}`,
  getTableHeadLabelId: id => `table-head.label-${id}`,
  getLoanDenialRowId: id => `${UnderwritingTestIdsScope.LOAN_DENIAL}.row-${id}`,

  // LoanDenial
  LOAN_DENIAL_ADD_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL}.add-button`,
  LOAN_DENIAL_TABLE: `${UnderwritingTestIdsScope.LOAN_DENIAL}.table`,
  LOAN_DENIAL_ACTION_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL}.action-button`,
  LOAN_DENIAL_FORM_LOAN_DENIAL_REASON_DATA_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.loan-denial-reason-data-button`,
  LOAN_DENIAL_FORM_REASON_SELECT: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.reason-select`,
  LOAN_DENIAL_FORM_HMDA_CODE_INPUT: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.hmda-code-input`,
  LOAN_DENIAL_FORM_CREDIT_CHECKBOX: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.credit-checkbox`,
  LOAN_DENIAL_FORM_AFFILIATE_CHECKBOX: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.affiliate-checkbox`,
  getLoanDenialFormBorrowerCheckboxId: index =>
    `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.borrower-${index}-checkbox`,

  // UnderwritingSummary
  SUMMARY_SECTION: `${TestIdDomain.UNDERWRITING}.summary-section`,

  // Notes (inline)
  NOTES_DATA_BUTTON: `${TestIdDomain.UNDERWRITING}.notes-data-button`,

  // AddConditionFormTaskType (inline)
  BROKER_CONDITION_FORM_STATE_SELECT: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.state-select`,
  BROKER_CONDITION_FORM_FORM_ID_SELECT: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.form-id-select`,

  // SuspenseReason
  SUSPENSE_REASON_SECTION: `${TestIdDomain.UNDERWRITING}.suspense-reason-section`,

  // General (inline)
  GENERAL_FORM_LOAN_EXPIRATION_DATE_DATA_BUTTON: `${UnderwritingTestIdsScope.GENERAL_FORM}.loan-expiration-date-data-button`,
  ADD_BROKER_CONDITION_FORM_ASSIGNEE_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.assignee-select`,
  ADD_BROKER_CONDITION_FORM_ASSIGNEE_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.assignee-option`,
  ADD_BROKER_CONDITION_FORM_ENTITY_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.entity-select`,
  ADD_BROKER_CONDITION_FORM_ENTITY_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.entity-option`,
  ADD_BROKER_CONDITION_FORM_FORM_TYPE_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.form-type-select`,
  ADD_BROKER_CONDITION_FORM_FORM_TYPE_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.form-type-option`,
  ADD_BROKER_CONDITION_FORM_PRIOR_TO_AUTOCOMPLETE_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.prior-to-autocomplete-select`,
  ADD_BROKER_CONDITION_FORM_PRIOR_TO_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.prior-to-option`,
  ADD_BROKER_CONDITION_FORM_CONDITIONS_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.conditions-select`,
  ADD_BROKER_CONDITION_FORM_CONDITIONS_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.conditions-option`,
  ADD_BROKER_CONDITION_FORM_CONDITION_SETS_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.condition-sets-select`,
  ADD_BROKER_CONDITION_FORM_CONDITION_SETS_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.condition-sets-option`,
  ADD_BROKER_CONDITION_FORM_PRIOR_TO_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.prior-to-select`,
  ADD_BROKER_CONDITION_FORM_STATUS_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.status-select`,
  ADD_BROKER_CONDITION_FORM_STATUS_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.status-option`,
};
